import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InlineItem } from "@common/InlineItem";
import { useStyle } from "./style";
import { ISimplePaymentMethodCard } from "./ISimplePaymentMethodCard";
import { getCardTypeLogoSrc } from "./utils/getCardTypeLogoSrc";
import { formatDateExpiry } from "@utils/dateFormat";

interface IParams {
    paymentMethod: ISimplePaymentMethodCard;
}

export const SimplePaymentMethodCardCell = (props: IParams) => {
    const { paymentMethod } = props;
    const { t } = useTranslation("payment");
    const { classes } = useStyle();
    const formattedDate = paymentMethod.expirationDate ? formatDateExpiry(new Date(paymentMethod.expirationDate)) : "";

    const cardTypeLogoSrc = getCardTypeLogoSrc(paymentMethod.creditCardType);

    return (
        <>
            <Grid className={classes.paymentCardImageContainer} item md={2} xs={5}>
                <img alt={paymentMethod.creditCardType} className={classes.paymentCardImage} src={cardTypeLogoSrc} />
            </Grid>
            <Grid item md={10} xs={7}>
                <Typography color="textPrimary" variant="small">
                    {paymentMethod.partialDigits}
                </Typography>
                <Box display="flex" flexWrap="wrap" justifyContent="space-between" paddingTop={2}>
                    <Typography color="textPrimary" variant="small">
                        {paymentMethod.cardholderName}
                    </Typography>
                    <InlineItem fieldName={t("cardExpirationDate")} itemGridSize={4} value={formattedDate} />
                </Box>
            </Grid>
        </>
    );
};
